import React from 'react'
import { MenuItem, TextField } from '@material-ui/core'
import { ProjectVersionFragment } from '../../generated/graphql'
import {
  HierarchicalVersion,
  createVersionHierarchy,
} from '../../project-versions/version-util'

export type DefaultVersionPickerProps = {
  versions: ProjectVersionFragment[]
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}

export function ProjectVersionPicker({
  value,
  onChange,
  versions,
  disabled = false,
}: DefaultVersionPickerProps): React.ReactElement {
  const versionsByHierarchy = createVersionHierarchy(versions)

  const menuItems: React.ReactElement[] = []

  const addToItems = (version: HierarchicalVersion, padding = 2) => {
    const element = (
      <MenuItem
        key={version.id}
        value={version.id}
        style={{ paddingLeft: `${padding * 8}px` }}
      >
        {version.name}
      </MenuItem>
    )
    menuItems.push(element)

    version.subVersions.forEach((v) => addToItems(v, padding + 2))
  }

  versionsByHierarchy.forEach((v) => addToItems(v))

  return (
    <TextField
      id="project-version"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      select
      disabled={disabled}
    >
      {menuItems}
    </TextField>
  )
}
